module.exports = {
	"body-no-scroll": "findify-components-common--drawer__body-no-scroll",
	"bodyNoScroll": "findify-components-common--drawer__body-no-scroll",
	"backdrop": "findify-components-common--drawer__backdrop",
	"content": "findify-components-common--drawer__content"
};